import { Injectable } from '@angular/core';
import { LpRIDTexts } from '../../typings/schema';
import { AudioPlayer } from '../utils/audio.utils';

@Injectable()
export class TextsService {
  private readonly texts = new Map<string, LpRIDTexts>();

  public async initialize(texts: LpRIDTexts[]) {
    for (const text of texts) {
      this.texts.set(text.key, text);
    }
  }

  public getItem(key: string): { text: string; audioUrl: string | undefined } {
    const item = this.texts.get(key);
    if (!item) {
      throw new Error(`Text '${key}' not found`);
    }

    return { text: item.text.text, audioUrl: item.text.audio?.url };
  }

  public getText(key: string): string {
    return this.getItem(key).text;
  }

  public async tryPronounce(key: string): Promise<void> {
    const { audioUrl } = this.getItem(key);
    if (!audioUrl) return;

    await AudioPlayer.play(audioUrl);
  }
}
